import { TextFieldMask } from "@inputs/text/TextFieldMask";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, InputAdornment } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";
import type { useDRDPHeader } from "../views/day/header/logics";
import type { useDRMPHeader } from "../views/month/header/logics";
import type { useDRYPHeader } from "../views/year/header/logics";
import { DRPHeaderContainer, headerClasses } from "./styles";

type IDRPHeader = ReturnType<typeof useDRDPHeader | typeof useDRMPHeader | typeof useDRYPHeader> & {
  placeholder: string;
  mask: string;
  labelStart: string;
  labelEnd: string;
  endDateDisabled?: boolean;
};

export const DRPHeader = ({
  control,
  submit,
  error,
  mask,
  placeholder,
  labelStart,
  labelEnd,
  required,
  endDateDisabled,
}: IDRPHeader) => {
  const [startDate, endDate] = useWatch({ control, name: ["startDate", "endDate"] });
  return (
    <DRPHeaderContainer className={headerClasses.root} columnGap={6} perLine={2}>
      <Controller
        control={control}
        name="startDate"
        render={({ field: { value, onChange }, formState: { errors } }) => (
          <TextFieldMask
            value={value}
            onAccept={(value) => {
              if (value !== startDate) {
                onChange(value);
              }
              if (value !== startDate && value === "") {
                submit();
              }
            }}
            onComplete={(value) => {
              if (value !== startDate) {
                submit();
              }
            }}
            error={!!errors.startDate || !!error.startDate}
            helperText={errors.startDate?.message || error.startDate}
            label={`${labelStart}${required?.startDate ? " *" : ""}`}
            placeholder={placeholder}
            size="small"
            fullWidth
            maskOptions={{
              mask,
            }}
            InputProps={{
              endAdornment: value && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      onChange("");
                      submit();
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
      <Controller
        control={control}
        name="endDate"
        render={({ field: { value, onChange }, formState: { errors } }) => (
          <TextFieldMask
            value={value}
            onAccept={(value) => {
              if (value !== endDate) {
                onChange(value);
              }
              if (value !== endDate && value === "") {
                submit();
              }
            }}
            onComplete={(value) => {
              if (value !== endDate) {
                submit();
              }
            }}
            error={!!errors.endDate || !!error.endDate}
            helperText={errors.endDate?.message || error.endDate}
            label={`${labelEnd}${required?.endDate ? " *" : ""}`}
            placeholder={placeholder}
            size="small"
            fullWidth
            disabled={endDateDisabled}
            maskOptions={{
              mask: [{ mask }, { mask: "" }],
            }}
            InputProps={{
              endAdornment: value && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      onChange("");
                      submit();
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </DRPHeaderContainer>
  );
};
